module.exports = __webpack_public_path__ + "fonts/Gilroy-RegularItalic.d2d1a69f.eot";